import { nsContract, nsTerminal } from '@/app/i18n/namespaces';
import { CB_VERSION_TYPE_SELECT_FILTERS } from '@/app/modules/contracts/enums/CbVersionType';
import APPLICATIONS from '@/app/modules/contracts/enums/ItpRegex';
import SSL_PARAMETERS from '../../terminals/enums/SslParameters';
import ERT_CODES from '@/app/modules/contracts/enums/ErtCodes';
import NETWORK_INTERFACE_TYPE from '../../terminals/enums/NetworkInterfaceType';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';


export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    UUIDS_CONTRACTS: {
        key: 'uuidsContracts'
    },
    APPLICATION: {
        key: 'application',
        type: FIELD_TYPES.TEXT,
        enableSorting: true,
        entity: 'keys.application',
        namespace: nsContract,
        filter: FILTER_TYPES.SELECT,
        enum: APPLICATIONS,
        sortOptions: true
    },
    NUMBER: {
        key: 'number',
        altKey: 'contract',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.contract_number',
        namespace: nsContract,
        placeholder: 'filter.placeholder.contract',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    // Libellé contrat 2
    LABEL: {
        key: 'label',
        altKey: 'contractLabel',
        entity: 'keys.label',
        type: FIELD_TYPES.TEXT,
        validate: value => !value || value && /^.{0,255}$/.test(value) ? undefined : 'INVALID',
        namespace: nsContract,
        placeholder: 'filter.placeholder.label',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    RANK: {
        key: 'rank',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.rank',
        validate: value => /^\d{3}$/.test(value) ? undefined : 'INVALID_RANK',
        maxLength: 3,
        isRequired: true,
        namespace: nsContract,
        placeholder: 'filter.placeholder.rank',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    // Libellé contrat
    MERCHANT_LABEL: {
        key: 'merchantLabel',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.merchant_label',
        validate: value => value && /^.{1,100}$/.test(value) ? undefined : 'REQUIRED',
        maxLength: 100,
        namespace: nsContract,
        placeholder: 'filter.placeholder.merchant_label',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    ALMA_LABEL: {
        key: 'merchantLabel',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.merchant_label',
        validate: value => {
            if (!value) {
                return undefined;
            }
            if (!/^.{1,12}$/.test(value)) {
                return 'REQUIRED';
            }
            value = value.split(' ').join('');
            if (/\W/.test(value)) {
                return 'BAD_FORMAT';
            }
        },
        isRequired: false,
        maxLength: 12,
        placeholder: 'modal_add_contract_access_merchant_alma_label_placeholder',
        labelHelp: 'modal_update_contract_access_alma_merchant_label_label_help'
    },
    BANK_CODE: {
        key: 'bankCode',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.bank_code',
        isRequired: true,
        namespace: nsContract,
        placeholder: 'filter.placeholder.bank_code',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    X25_ADDRESS: {
        key: 'x25Address',
        type: FIELD_TYPES.TEXT,
        namespace: nsContract,
        entity: 'keys.x25_address',
        validate: value => /^\d+$/.test(value) ? undefined : 'BAD_FORMAT',
        maxLength: 20,
        placeholder: 'filter.placeholder.x25_address',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    POS_TERMINAL: {
        key: 'posTerminal',
        UUID: {
            parentKeys: ['posTerminal'],
            key: 'uuid'
        },
        SERIAL_NUMBER: {
            parentKeys: ['posTerminal'],
            key: 'serialNumber',
            namespace: nsContract,
            entity: 'keys.serial_number',
            placeholder: 'filter.placeholder.serial_number',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true,
            isNested: true
        },
        MANUFACTURER: {
            parentKeys: ['posTerminal'],
            key: 'manufacturer',
            type: FIELD_TYPES.TEXT,
            namespace: nsContract,
            entity: 'keys.manufacturer',
            validate: (value, allValues, props) => {
                let val = 'REQUIRED';

                if (value) {
                    val = props.manufacturersList.find(manufacturerItem => manufacturerItem.value === value) ? undefined : 'BAD_MANUFACTURER';
                }
                return val;
            },
            placeholder: 'filter.placeholder.manufacturer',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true,
            isNested: true
        }
    },
    CREATION_AUTO: {
        key: 'isAutomaticCreation',
        type: FIELD_TYPES.TEXT,
        prefix: 'contractCreationType_',
        entity: 'merchantContract_auto_creation'
    },
    ITP: {
        key: 'itp',
        type: FIELD_TYPES.TEXT,
        namespace: nsContract,
        entity: 'keys.itp',
        placeholder: 'filter.placeholder.itp',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    CB_VERSION: {
        key: 'cbVersion',
        type: FIELD_TYPES.TEXT,
        prefix: 'cbVersionType_',
        namespace: nsContract,
        entity: 'keys.cb_version',
        enum: CB_VERSION_TYPE_SELECT_FILTERS,
        filter: FILTER_TYPES.SELECT,
        enableSorting: true
    },
    LEGAL_AND_BUSINESS_NAME: {
        key: 'legalAndBusinessName',
        type: FIELD_TYPES.TEXT,
        enableSorting: true,
        entity: 'keys.legal_and_business_name',
        namespace: nsContract,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.legal_and_business_name'
    },
    LEGAL_INFOS: {
        key: 'legalInfos'
    },
    REGISTRATION_NUMBER: {
        key: 'registrationNumber',
        altKey: 'siret',
        type: FIELD_TYPES.TEXT,
        namespace: nsContract,
        entity: 'keys.registration_number',
        placeholder: 'filter.placeholder.registration_number',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    LEGAL_BUSINESS_NAME: {
        key: 'legalAndBusinessName',
        type: FIELD_TYPES.TEXT,
        namespace: nsContract,
        entity: 'keys.legal_name',
        placeholder: 'filter.placeholder.legal_name',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    LAST_SOURCE_IP: {
        key: 'lastSourceIp',
        enableSorting: false
    },
    LAST_ICCID: {
        key: 'lastIccid',
        type: FIELD_TYPES.TEXT,
        namespace: nsContract,
        entity: 'keys.last_iccid',
        placeholder: 'filter.placeholder.last_iccid',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    LAST_ICCID_OPERATOR: {
        key: 'lastIccidOperator',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.last_iccid_operator',
        namespace: nsContract
    },
    ACTIVE_ICCID: {
        key: 'activeIccid',
        type: FIELD_TYPES.TEXT,
        entity: 'merchantContract_active_iccid'
    },
    LAST_CONNECTION_TYPE: {
        key: 'lastConnectionType',
        type: FIELD_TYPES.TEXT,
        enableSorting: true,
        entity: 'keys.network_interface_type',
        namespace: nsTerminal,
        filter: FILTER_TYPES.SELECT,
        enum: NETWORK_INTERFACE_TYPE
    },
    LAST_REMOTE_COLLECTION_DATE: {
        key: 'lastRemoteCollectionDate',
        type: FIELD_TYPES.DATE,
        namespace: nsContract,
        entity: 'keys.last_remote_collection_date',
        filter: FILTER_TYPES.DATE,
        enableSorting: true
    },
    LAST_CONNECTION_DATE: {
        key: 'lastConnectionDate',
        type: FIELD_TYPES.TEXT,
        entity: 'merchantContract_last_connection_date'
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        namespace: nsContract,
        entity: 'keys.created_at',
        filter: FILTER_TYPES.DATE,
        enableSorting: true
    },
    ADDED_AT: {
        key: 'addedAt',
        altKey: 'createdAt',
        type: FIELD_TYPES.DATE,
        namespace: nsContract,
        entity: 'keys.added_at',
        filter: FILTER_TYPES.DATE,
        enableSorting: true
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: FIELD_TYPES.DATE,
        entity: 'merchantContract_updated_at'
    },
    OPERATOR: {
        key: 'operator',
        type: FIELD_TYPES.TEXT,
        entity: 'merchantContract_operator'
    },
    LAST_SSL_VERSION: {
        key: 'lastSslVersion',
        type: FIELD_TYPES.TEXT,
        namespace: nsContract,
        entity: 'keys.last_ssl_version',
        filter: FILTER_TYPES.SELECT,
        enum: SSL_PARAMETERS,
        enableSorting: true
    },
    REMPART: {
        MODEL: {
            key: 'model',
            type: FIELD_TYPES.TEXT,
            namespace: nsContract,
            entity: 'keys.model',
            placeholder: 'filter.placeholder.model',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true
        },
        SPECIFICATION: {
            key: 'specification',
            type: FIELD_TYPES.TEXT,
            namespace: nsContract,
            entity: 'keys.specification',
            placeholder: 'filter.placeholder.specification',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true
        },
        BULLETINS: {
            key: 'appliedBulletins',
            type: FIELD_TYPES.TEXT,
            namespace: nsContract,
            entity: 'keys.bulletins',
            placeholder: 'filter.placeholder.bulletins',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true
        },
        ERT: {
            key: 'ert',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.ert',
            namespace: nsContract
        },
        ERT_CODE: {
            key: 'ertCode',
            type: FIELD_TYPES.TEXT,
            namespace: nsContract,
            entity: 'keys.ert_code',
            customPrefix: 'rempart_ert_',
            filter: FILTER_TYPES.SELECT,
            enableSorting: true,
            enum: ERT_CODES
        },
        CB_AGREEMENT_NUMBER: {
            key: 'cbApproval',
            type: FIELD_TYPES.TEXT,
            namespace: nsContract,
            entity: 'keys.cb_agreement_number',
            placeholder: 'filter.placeholder.cb_agreement_number',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true
        },
        CB_APPROVAL: {
            key: 'cbApproval',
            type: FIELD_TYPES.TEXT,
            enableSorting: true,
            entity: 'keys.cb_approval',
            namespace: nsContract,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.cb_approval'
        },
        CB_APPROVAL_DATE: {
            key: 'cbApprovalDate',
            type: FIELD_TYPES.DATE,
            namespace: nsContract,
            entity: 'keys.cb_approval_date',
            filter: FILTER_TYPES.DATE,
            enableSorting: true
        },
        PCI_VERSION: {
            key: 'pciVersion',
            type: FIELD_TYPES.TEXT,
            namespace: nsContract,
            entity: 'keys.pci_version',
            placeholder: 'filter.placeholder.pci_version',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true
        },
        PCI_EXPIRATION_DATE: {
            key: 'pciExpirationDate',
            type: FIELD_TYPES.DATE,
            namespace: nsContract,
            entity: 'keys.pci_expiration_date',
            filter: FILTER_TYPES.DATE,
            enableSorting: true
        },
        PCI_PP_VERSION: {
            key: 'pciPp16Version',
            type: FIELD_TYPES.TEXT,
            namespace: nsContract,
            entity: 'keys.pci_pp_version',
            placeholder: 'filter.placeholder.pci_pp_version',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true
        },
        PCI_PP_EXPIRATION_DATE: {
            key: 'pciPpExpirationDate',
            type: FIELD_TYPES.DATE,
            namespace: nsContract,
            entity: 'keys.pci_pp_expiration_date',
            filter: FILTER_TYPES.DATE,
            enableSorting: true
        },
        END_OF_USE_DATE: {
            key: 'endOfUseDate',
            type: FIELD_TYPES.DATE,
            namespace: nsContract,
            entity: 'keys.end_of_use_date',
            filter: FILTER_TYPES.DATE,
            enableSorting: true
        },
        EXPIRATION_DATE: {
            key: 'expirationDate',
            type: FIELD_TYPES.DATE,
            namespace: nsContract,
            entity: 'keys.expiration_date',
            filter: FILTER_TYPES.DATE,
            enableSorting: true
        },
        END_OF_DEPLOYMENT_DATE: {
            key: 'endOfDeploymentDate',
            type: FIELD_TYPES.DATE,
            namespace: nsContract,
            entity: 'keys.end_of_deployment_date',
            filter: FILTER_TYPES.DATE,
            enableSorting: true
        }
    },
    SIM_STATUS: {
        key: 'simStatus',
        type: FIELD_TYPES.TEXT,
        entity: 'posTerminal_simCard_status'
    },
    MCC: {
        key: 'mcc',
        type: FIELD_TYPES.TEXT,
        namespace: nsContract,
        entity: 'keys.mcc',
        placeholder: 'filter.placeholder.mcc',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    IDSA: {
        key: 'idsa',
        type: FIELD_TYPES.TEXT,
        namespace: nsContract,
        entity: 'keys.idsa',
        placeholder: 'filter.placeholder.idsa',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    MERCHANT_NAME: {
        key: 'merchantName',
        type: FIELD_TYPES.TEXT,
        namespace: nsContract,
        entity: 'keys.merchant_name',
        placeholder: 'filter.placeholder.merchant_name',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    MERCHANT_LEGAL_NAME: {
        key: 'merchantLegalName'
    }
};